<template>
  <!-- <div class="StudyHomePage" v-if="selectedStudy && tabConfig"> -->
		<div class="StudyHomePage" >
			<v-app-bar dense class="appStudyBar">
			<v-toolbar-title>
				<v-btn class="btn-default" icon @click="$router.push('/landing')" text height="38" width="38"><v-icon>home</v-icon></v-btn>
			</v-toolbar-title>
		</v-app-bar>
		<v-card
			flat
			class="tab-container"
		>
			<template>
        <v-tabs
					centered
					hide-slider
					class="tabs"
					v-model="tabs"
        >
          <v-tab class="no-underline tab-font-color" v-on:click="page='Messages'"  style="width: 25%" href='#tab-messages'>
						Messages
          </v-tab>
					<v-tab class="no-underline tab-font-color" v-on:click="page='Users'" style="width: 25%" href='#tab-users'>
            <v-icon left></v-icon>
						Users
          </v-tab>
					<v-tab class="no-underline tab-font-color" v-on:click="page='Studies'" style="width: 25%" href='#tab-studies'>
            <v-icon left></v-icon>
						Studies
          </v-tab>
					<v-tab class="no-underline tab-font-color" v-on:click="page='Logs'" style="width: 25%" href='#tab-logs'>
            <v-icon left></v-icon>
						Logs
          </v-tab>
        </v-tabs>
      </template>
			<messages v-if="page === 'Messages'" ref="mesFocus"></messages>
			<users :userToDisplay="userToDisplay" v-if="page === 'Users'" ref="useFocus"></users>
			<studies @seeUserDetails="loadUserDetails" v-if="page === 'Studies'" ref="stuFocus"></studies>
			<logs v-if="page === 'Logs'" ref="logFocus"></logs>
    </v-card>
  </div>
</template>

<script>
export default {
	name: 'AdminPage',
	props: {
	},
	metaInfo: {
		title: 'Admin'
	},
	data: () => ({
		page: 'Messages',
		userToDisplay: '',
		tabs: 'tab-messages'
	}),
	watch: {
		page: function (page) {
			this.$nextTick(function () {
				if (page === 'Messages') {
					this.$refs.mesFocus.$refs.mmFocus.$refs.firstFocus.focus();
				}
				if (page === 'Users') {
					this.$refs.useFocus.$refs.firstFocus.focus();
					this.userToDisplay = '';
				}
				if (page === 'Studies') {
					this.$refs.stuFocus.$refs.firstFocus.focus();
				}
				if (page === 'Logs') {
					this.$refs.logFocus.$refs.firstFocus.focus();
				}
			})
		}
	},
	mounted () {
		// this.$store.dispatch('endImpersonation');
		this.$nextTick(function () {
			this.$refs.mesFocus.$refs.mmFocus.$refs.firstFocus.focus()
		})
	},
	methods: {
		loadUserDetails (userName) {
			this.userToDisplay = userName;
			this.page = 'Users';
			this.tabs = 'tab-users';
		}
	}
}
</script>

<style>
.no-underline:hover{
  text-decoration: none;
}
a.tab-font-color {
  color: black !important;
}

</style>
